export default __webpack_public_path__ + "static/media/sorriso.564d44a3.mp4";